(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .factory('ExportadorService', ExportadorService);

  ExportadorService.$inject = [
    '$http',
    '$q'
  ];

  // eslint-disable-next-line max-lines-per-function
  function ExportadorService($http, $q) {
    //////////////////////////////////////////
    // Service data

    //////////////////////////////////////////
    // Service object declaration
    const service = {
      availableTypes,
      availableFilters,
      createReport,
      getJobProgress
    };
    return service;

    //////////////////////////////////////////
    // Function declarations

    function availableTypes() {
      return $http.get(`${SERVER}v1/exportador`)
        .then((response) => response.data);
    }

    function availableFilters(type) {
      if (type === void 0 || !type.name) {
        return $q.reject('No type selected!');
      }

      return $http.get(`${SERVER}v1/exportador/${type.name}`)
        .then((response) => response.data);
    }

    function createReport(type, filters) {
      return $http.post(`${SERVER}v1/exportador/${type.name}`, null, {
        params: getFilters(filters)
      })
        .then((response) => response.data);
    }

    function getFilters(filters) {
      return Object.keys(filters).reduce((params, filter) => {
        // eslint-disable-next-line max-len
        params[filter] = filters[filter] instanceof Array ? getArrayIds(filters[filter]) : filters[filter].id || filters[filter];
        return params;
      }, {});
    }

    function getArrayIds(array) {
      return array.map((value) => value.id).join();
    }

    function getJobProgress(relatorio) {
      return $http.get(`${SERVER}v1/job_status/${relatorio.job_id}/progress`)
        .then((response) => response.data);
    }
  }
}());
